import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IStatusAddPayload, IStatusUpdatePayload } from './statusuri-proiecte.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StatusuriProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listStatusuriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.list;
    private listDTStatusuriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.listDT;
    private addStatusURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.store;
    private updateStatusURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.update;
    private deleteStatusURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.changeActive;
    private listStatusuriActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.listActive;
    private listStatusuriAllActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteStatus.listAllActive;

    constructor(private http: HttpClient) { }

    listStatusuri() {
        return this.http.get(this.listStatusuriURL);
    }

    listDTStatusuri() {
        return this.http.post(this.listDTStatusuriURL, {});
    }

    addStatus(data: IStatusAddPayload) {
        return this.http.post(this.addStatusURL, data);
    }

    updateStatus(data: IStatusUpdatePayload) {
        return this.http.put(this.updateStatusURL, data);
    }

    deleteStatus(id: number) {
        return this.http.delete(this.deleteStatusURL + id);
    }

    listStatusuriActive() {
        return this.http.get(this.listStatusuriActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    getStatusuriAllActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listStatusuriAllActiveURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        arhiva: item.arhiva,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities:', error);
                    return throwError(error);
                })
            );
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
